import React from "react";
import { Alert, Row, Col, Form, Button } from "reactstrap";
import { Link, Navigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import AuthHeader from "../../components/AuthHeader";
import FormInput from "../../components/FormInput";
import Loader from "../../components/Loader";

import { useAuth } from "../../context/AuthContext";
import { useRecoverPassword } from "../../hooks/useRecoverPassword";

const RecoverPassword: React.FC = () => {

  const { user } = useAuth();
  const { loading, error, successMsg, recover } = useRecoverPassword();

  // schema primeiro
  const resolver = yupResolver(
    yup.object().shape({
      email: yup
        .string()
        .email("This value should be a valid email.")
        .required("Please Enter E-mail."),
    })
  );

  // hook TEM QUE vir antes de qualquer return condicional
  const methods = useForm({
    defaultValues: {},
    resolver,
  });

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = methods;

  // depois — aí pode retornar sem problema
  if (user) {
    return <Navigate to="/dashboard" />;
  }

  const onSubmitForm = async (values: any) => {
    await recover(values);
  };

  return (
    <NonAuthLayoutWrapper>
      <Row className=" justify-content-center my-auto">
        <Col sm={8} lg={6} xl={5} className="col-xxl-4">
          <div className="py-md-5 py-4">
            <AuthHeader
              title="Reset Password"
              subtitle="Reset Password with Doot."
            />

            {error && <Alert fade timeout={150} color="danger">{error}</Alert>}

            {successMsg && <Alert fade timeout={150} color="success">{successMsg}</Alert>}

            {!error && !successMsg && (
              <Alert fade timeout={150} color="info" className="text-center my-4">
                Enter your Email and instructions will be sent to you!
              </Alert>
            )}

            <Form onSubmit={handleSubmit(onSubmitForm)} className="position-relative">
              {loading && <Loader />}

              <div className="mb-3">
                <FormInput
                  label="Email"
                  type="text"
                  name="email"
                  register={register}
                  errors={errors}
                  control={control}
                  labelClassName="form-label"
                  placeholder="Enter Email"
                  className="form-control"
                />
              </div>

              <div className="text-center mt-4">
                <Button color="primary" className="w-100" type="submit">
                  Reset
                </Button>
              </div>
            </Form>

            <div className="mt-5 text-center text-muted">
              <p>
                Remember It?{" "}
                <Link
                  to="/auth-login"
                  className="fw-medium text-decoration-underline"
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default RecoverPassword;
